export const getAddButtonLabel = ({
  checkedItemsCount,
  singularCountSuffix,
  pluralCountSuffix,
}: {
  checkedItemsCount?: number;
  pluralCountSuffix?: string;
  singularCountSuffix?: string;
}) => {
  const isSingularCase = checkedItemsCount && checkedItemsCount % 10 === 1;
  const isPluralCase = checkedItemsCount && checkedItemsCount > 1;

  if (isSingularCase) {
    return `Add (${checkedItemsCount} ${singularCountSuffix})`;
  }

  if (isPluralCase) {
    return `Add (${checkedItemsCount} ${pluralCountSuffix})`;
  }

  return 'Add';
};
